import { StandardFormSelect } from "collections/Form";
import { DetailsLoader } from "elements";
import {
  UserGroupSourceType,
  useUserGroupsForTenantQuery
} from "generated/graphql";
import React, { Dispatch } from "react";
import { useTranslation } from "utilities/i18n";
import { GroupMutationData } from "./UserGroupMutationForm";

export const GroupDropdown: React.FC<{
  setGroupData: Dispatch<React.SetStateAction<GroupMutationData>>;
  tenantId: string;
}> = ({ setGroupData, tenantId }) => {
  const { t } = useTranslation();

  const { data, fetching } = useUserGroupsForTenantQuery({
    variables: { tenantId: tenantId }
  });

  const groupList =
    data?.userGroupsForTenant
      .filter(group => group.source === UserGroupSourceType.Lens)
      .map(group => ({
        text: group.name,
        value: group.id
      })) ?? [];

  return (
    <DetailsLoader loading={fetching} title={t("LOADING")}>
      <div className="form-content">
        {groupList.length > 0 ? (
          <StandardFormSelect
            label={t("GROUP")}
            name="id"
            options={groupList || []}
            tabIndex={2}
            onSelectionChange={id => {
              const group = groupList.find(group => group.value === id);
              setGroupData(state =>
                group?.text
                  ? {
                      id,
                      name: group.text
                    }
                  : state
              );
            }}
            inline={true}
          />
        ) : (
          <span>{t("NO_DEVICE_USER_GROUPS")}</span>
        )}
      </div>
    </DetailsLoader>
  );
};
